import React, { useEffect } from 'react';
import '../assets/styles/MouseTrail.css';

const MouseTrail: React.FC = () => {
    useEffect(() => {
        const handleMouseMove = (e: MouseEvent) => {
            const toRemove = document.getElementsByClassName('mouse-loader')[0];
            const trail = document.createElement('div');
            trail.className = 'mouse-loader';

            const inner = document.createElement('div');
            inner.className = 'loader';
            trail.appendChild(inner);


            trail.style.position = 'fixed';  // 👈 Important
            trail.style.left = `${e.clientX - 0}px`;
            trail.style.top = `${e.clientY - 0}px`;
            trail.style.pointerEvents = 'none'; // 👈 So it doesn’t interfere with clicks

            document.body.appendChild(trail);

            if (document.getElementsByClassName('mouse-loader').length > 50) {
                if (toRemove && toRemove.parentNode) {
                    toRemove.parentNode.removeChild(toRemove);
                }
            }
        };

        window.addEventListener('mousemove', handleMouseMove);
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
        };
    }, []);

    return null;
};

export default MouseTrail;

